import { useEffect, useState } from "react";
import { Page, Block, Segmented, SegmentedButton } from "konsta/react";
import { useSetRecoilState } from "recoil";
import { useNavigate } from "react-router-dom";

import GlobalSearch from "../../Utils/GlobalSearch/GlobalSearch";
import RecentItems from "../../Utils/RecentItems/RecentItems";
import WorkOrderScheduled from "./WorkOrderScheduled";
import Spinner from "../../Utils/Loading/Spinner";

import { globalSearchTables } from "../../../dbTables/syncObjects";
import { globalNavbarOptions, globalSearchFocusState } from "../../State/Global";
import { useSignedInUser } from '../../Hooks/Hooks';
import { pageRoutes } from "../../../routes/routes";

export default function WorkOrderHome() {
    const woDetailNav = pageRoutes.find((route) => route.id === "work-order-detail-page")?.nav;
    const workOrderTable = globalSearchTables.find(searchTable => searchTable.ref === "pffsm__smWork_Order__c");

    const [ activeNavigation, setActiveNavigation ] = useState(0);
    const [ query, setQuery ] = useState("");
    const [ dropSelect, setDropSelect ] = useState();
    const [ isLoading, setIsLoading ] = useState(true);

    const setNavbarOptions = useSetRecoilState(globalNavbarOptions);
    const setHasFocus = useSetRecoilState(globalSearchFocusState);
    const navigate = useNavigate();
    const [ user ] = useSignedInUser();

    const mainWOTable = {
        ...workOrderTable,
        fields: [
            "Name",
            "pffsm__Description__c",
            "pffsm__Equip_Description__c",
            "pffsm__Priority__c"
        ]
    }

    useEffect(() => {
        setNavbarOptions({
            title: "Work Orders",
            page: "work-order-page",
            hasLeft: false,
            hasRight: true
        });
    }, []);

    useEffect(() => {
        if (user) {
            setIsLoading(false);
        }
    }, [ user ])

    useEffect(() => {
        if(dropSelect !== undefined) {
            var assignId = dropSelect.id;
            navigate(`${woDetailNav}${assignId}`)
        }
    },[ dropSelect ]);

    const getContent = () => {
        if (activeNavigation === 0) {
            return (<WorkOrderScheduled currentUserId={user.sfUserId} />);
        } else if (activeNavigation === 1) {
            return (<RecentItems type={["pffsm__smWork_Order__c"]}/>);
        }

        return (<div>Page Not Found</div>);
    }

    const userInputChange = (e) => {
        setQuery(e.target.value);
    }

    const searchButtonClick = (e) => {
        setHasFocus(true);
    }

    return (
        <Page id="scrollable" className="mt-12">
            { isLoading ?
                <Spinner /> :
                <>
                    <Block margin="my-2" className="z-10">
                        <GlobalSearch searchObjects={[ mainWOTable ]} query={query} userInputChange={ userInputChange }
                            searchButtonClick={ searchButtonClick} displayField="Name" subtextField="pffsm__Description__c"
                            setSelected={ setDropSelect } showdrop qrysuggest />
                    </Block>

                    <Block margin="my-4" className="z-0">
                        <Segmented outline rounded>
                            <SegmentedButton active={activeNavigation === 0} onClick={() => setActiveNavigation(0)}>
                                My Open WO
                            </SegmentedButton>
                            <SegmentedButton active={activeNavigation === 1} onClick={() => setActiveNavigation(1)}>
                                Recent Items
                            </SegmentedButton>
                        </Segmented>
                    </Block>

                    <div className="relative z-0">
                        <Block margin="my-0">
                            { getContent() }
                        </Block>
                    </div>
                </>
            }
        </Page>
    );
}